<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
@font-face {
  font-family: 'bingyuyasong';
  src: url('https://oss.mcloud.moveclub.cn/mcloudbkh5/20220921/1663727327-632a76df892e8.ttf');
  font-weight: normal;
  font-style: normal;
}

.yasong {
  font-family: 'bingyuyasong';
}
</style>
